var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"menu-notification",attrs:{"to":{ name: 'chat' }}},[_c('BaseIcon',{attrs:{"icon":"chat-main"}}),(_vm.countNewNotifications > 0)?_c('div',{staticClass:"menu-notification_badge f12",attrs:{"data-text":_vm.countNewNotifications}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }